import { EPersonalVerifyStatus } from '../enums/personal-verification.enum';

export interface PersonalVerifyDto {
  id: number;
  action: EPersonalVerifyStatus;
  reason?: string;
}
